import styles from './MenuHeaderDefault.module.scss'
import Logo from '@/components/Logo/Logo'
import { clsx } from 'clsx'
import AppContext from '@/types/context'
import SidebarTriggerBtn from '@/elements/widgets/Menu/Header/Default/SidebarTriggerBtn'
import { Link } from '@/components/Link'
import AccountBtn from '@/elements/widgets/Menu/Header/Default/AccountBtn'

const MenuHeaderDefault = ({ context }: { context: AppContext }) => {
  return (
    <div
      className={clsx(styles.header, context.webview && styles.webview)}
      id="widget-menu-header-default"
      data-cy="widget-menu-header-default"
    >
      <aside />
      <div className={styles.container}>
        <div className={styles['left-block']}>{!context.webview && <SidebarTriggerBtn context={context} />}</div>
        <div className={styles['middle-block']}>
          <Link href="/sport/" target="_self" aria-label="Startseite" className={styles['logo-link']}>
            <Logo />
          </Link>
        </div>
        <div className={styles['right-block']}>
          <AccountBtn webview={context.webview} />
        </div>
      </div>
      <aside />
    </div>
  )
}

export default MenuHeaderDefault
